export default __webpack_public_path__ + "static/media/glrc-course.stock-sauces-soups.79ced4f1.png";